"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var selectFocusedInboxOption_1 = require("../actions/selectFocusedInboxOption");
var store_1 = require("../store/store");
var owa_options_core_1 = require("owa-options-core");
var ChoiceGroup_1 = require("office-ui-fabric-react/lib/ChoiceGroup");
var owa_session_store_1 = require("owa-session-store");
var owa_options_strings_1 = require("owa-strings/owa-options-strings");
var React = require("react");
var react_1 = require("satcheljs/lib/legacy/react");
var FocusedFull = /** @class */ (function (_super) {
    tslib_1.__extends(FocusedFull, _super);
    function FocusedFull() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onChange = function (ev, option) {
            selectFocusedInboxOption_1.default(option.key === 'true');
        };
        return _this;
    }
    FocusedFull.prototype.render = function () {
        var _a = this.props, optionStore = _a.optionStore, userOptions = _a.userOptions;
        var isFocusedEnabled = owa_options_core_1.getFallbackValueIfNull(optionStore.isEnabled, userOptions.IsFocusedInboxEnabled);
        return (React.createElement(ChoiceGroup_1.ChoiceGroup, { selectedKey: "" + isFocusedEnabled, label: owa_options_strings_1.default.options_focused_label, options: [
                {
                    key: 'true',
                    text: owa_options_strings_1.default.options_focused_enabled,
                },
                {
                    key: 'false',
                    text: owa_options_strings_1.default.options_focused_disabled,
                },
            ], onChange: this.onChange }));
    };
    FocusedFull = tslib_1.__decorate([
        react_1.reactive({
            optionStore: function () { return store_1.default; },
            userOptions: function () { return owa_session_store_1.getUserConfiguration().UserOptions; },
        })
    ], FocusedFull);
    return FocusedFull;
}(React.Component));
exports.default = FocusedFull;
//# sourceMappingURL=FocusedFull.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-focused-option/lib/components/FocusedFull.js
// module id = 5090
// module chunks = 2